import { useEffect } from "react";

// Pila de retroceso para deep links en WebView (Android).
//
// Cuando la app abre directo a una ruta profunda (deep link: /tienda/:slug,
// /paqueterias/:carrier, /rastrear, etc.), el historial del WebView tiene una
// sola entrada: el botón "atrás" de Android cierra la app de inmediato. La
// guía de Google Play (Unified Navigation & Back Stack) espera que "atrás"
// lleve primero a un padre lógico (el inicio de la app) antes de salir.
//
// En el primer cargado (history.length === 1) y si la ruta no es la raíz,
// insertamos una entrada "/" debajo de la ruta actual: reemplazamos la
// entrada actual por "/" y volvemos a empujar la ruta profunda encima. Así el
// back stack queda ["/", "/ruta-profunda"] y "atrás" navega al inicio primero.
//
// Usamos la History API nativa (no React Router) para no interferir con el
// estado interno del router; en el siguiente popstate, React Router lee la
// URL del evento y re-renderiza correctamente.
export default function DeepLinkBackStack() {
  useEffect(() => {
    try {
      const cur = window.location.pathname + window.location.search + window.location.hash;
      if (window.history.length === 1 && cur !== "/" && cur !== "") {
        window.history.replaceState(null, "", "/");
        window.history.pushState(null, "", cur);
      }
    } catch {
      /* noop: si la History API no está disponible, no alteramos nada */
    }
  }, []);

  return null;
}